module.exports = __webpack_public_path__ + "img/avatar-placeholder.b8c1b683.svg";